import { render, staticRenderFns } from "./informational-modal.vue?vue&type=template&id=874d9406"
import script from "./informational-modal.vue?vue&type=script&lang=js"
export * from "./informational-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports